<template>
	<Fragment>
		<BaseColumn class="text-right text-lg font-medium" :class="columnClass">
			<slot>
				<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
			</slot>
		</BaseColumn>
	</Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import BaseColumn from '@/components/columns/BaseColumn';

export default {
	name: 'SuffixColumn',
	components: { BaseColumn, Fragment },
	props: {
		icon: {},
		value: {},
		subValue: {},
		columnClass: {},
	},
};
</script>
